import { CircularProgress } from "@mui/joy";
import axios from "axios";
import React, { useState, useEffect } from 'react';
import OperationComponent from "./components/OperationComponent";
import ReactPaginate from "react-paginate";
function OperationsPage() {
    const [loading, setLoading] = useState(true);
    const [operations, setOperations] = useState([]);
    const [pageCount, setPageCount] = useState(1);
    useEffect(() => {
      loadOperations()
    }, []);

    async function loadOperations(page) {
  try {
    setLoading(true);
    const urlParams = new URLSearchParams(window.location.search);
    const pageParam = urlParams.get('page');
    const newPage = page ? page : pageParam ? parseInt(pageParam) : 1;
    const response = await axios.get('https://rechargemoi.ma/backend/api/operations/all?page='+newPage, {
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }});
    if (response.status === 200) {
      setPageCount(response.data.last_page);
      setOperations(response.data.data);

    }
  }catch (error) {
    console.error("Error loading operations:", error);
  }finally {
    setLoading(false);
  }
}
  if (loading) {
    return <div className="loading"><CircularProgress variant="solid" size='lg' color='neutral'/></div>;
  }  
  return (
    <div className="operations-page container">
            {operations.map((operation, index) =>(
                  <OperationComponent key={index} price={operation.price} name={operation.productName} client={operation.client} time={new Date(operation.time * 1000).toLocaleString('en-GB', { timeZone: 'Africa/Casablanca' })} success={operation.success} />
            ))}
    <div className="pagination">
      {/* <ReactPaginate
        breakLabel="..."
        nextLabel="next >"
        pageRangeDisplayed={5}
        pageCount={pageCount}
        onPageChange={(data) => {
          const newPage = data.selected + 1;
          window.history.pushState({}, '', `?page=${newPage}`);
          loadOperations(newPage);
        }}
        previousLabel="< previous"
        renderOnZeroPageCount={null}
      /> */}
      

      <div className="pagination-controls">
        {(() => {
          const currentPage = parseInt(new URLSearchParams(window.location.search).get('page') || 1);
          
          const handlePageClick = (page) => {
            window.history.pushState({}, '', `?page=${page}`);
            loadOperations(page);
          };
          
          return (
            <>
              <button 
                className="page-btn prev"
                onClick={() => handlePageClick(currentPage - 1)}
                disabled={currentPage === 1}
              >
                &lt; السابق
              </button>
              
              <button 
                className={`page-num ${currentPage === 1 ? 'active' : ''}`}
                onClick={() => handlePageClick(1)}
              >
                1
              </button>
              
              {currentPage > 3 && <span className="ellipsis">...</span>}
              
              {currentPage > 2 && (
                <button 
                  className="page-num"
                  onClick={() => handlePageClick(currentPage - 1)}
                >
                  {currentPage - 1}
                </button>
              )}
              
              {currentPage !== 1 && currentPage !== pageCount && (
                <button 
                  className="page-num active"
                  onClick={() => handlePageClick(currentPage)}
                >
                  {currentPage}
                </button>
              )}
              
              {currentPage < pageCount - 1 && (
                <button 
                  className="page-num"
                  onClick={() => handlePageClick(currentPage + 1)}
                >
                  {currentPage + 1}
                </button>
              )}
              
              {currentPage < pageCount - 2 && <span className="ellipsis">...</span>}
              
              {pageCount > 1 && (
                <button 
                  className={`page-num ${currentPage === pageCount ? 'active' : ''}`}
                  onClick={() => handlePageClick(pageCount)}
                >
                  {pageCount}
                </button>
              )}
              
              <button 
                className="page-btn next"
                onClick={() => handlePageClick(currentPage + 1)}
                disabled={currentPage === pageCount}
              >
                التالي &gt;
              </button>
            </>
          );
        })()}
      </div>
    </div>
    </div> 
        
  );}

export default OperationsPage;